export enum DeviceState {
	Offline = 'OFFLINE',
	Discovered = 'DISCOVERED',
	Online = 'ONLINE',
	Error = 'ERROR'
}
